(() => {
  const contact = document.getElementById('DaceinContact');
  if (!contact || contact.dataset.ready) return;
  contact.dataset.ready = 'true';
  const launcher = contact.querySelector('summary');
  const closeButton = contact.querySelector('[data-contact-close]');
  const close = (restoreFocus) => {
    contact.open = false;
    if (restoreFocus) launcher.focus();
  };
  closeButton.hidden = false;
  closeButton.addEventListener('click', () => close(true));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && contact.open) {
      const restoreFocus = contact.contains(document.activeElement);
      close(restoreFocus);
    }
  });
  document.addEventListener('click', (event) => {
    if (contact.open && !contact.contains(event.target)) close(false);
  });
})();
